const PageLayout = ({ children }) => (
  <div className="min-h-screen overflow-x-hidden relative" style={{ background: "var(--bg-primary)", color: "var(--text-primary)" }}>
    {children}
  </div>
);

export default PageLayout;
